<template>
  <div>
    <v-list-group v-model="menu">
      <template v-slot:activator>
        <v-list-item-avatar v-if="contextAvatar" size="32px" class="user-avatar">
          <img :src="contextAvatar" />
        </v-list-item-avatar>
        <v-list-item-action v-else-if="contextType === 'org'" class="user-avatar">
          <v-icon light v-text="$vuetify.icons.values.organization" class="fa-fw"></v-icon>
        </v-list-item-action>
        <v-list-item-action v-else class="user-avatar">
          <v-icon light v-text="$vuetify.icons.values.user" class="fa-fw"></v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ contextDisplay }}</v-list-item-title>
        </v-list-item-content>
      </template>

      <template v-for="(item, idx) in items">
        <v-list-item
          v-if="!item.header"
          :key="`context-item-${idx}`"
          @click="setContext(item)"
          :value="item.refname === contextRef"
        >
          <v-list-item-avatar v-if="item.avatar" size="32px" class="user-avatar">
            <img :src="item.avatar" />
          </v-list-item-avatar>
          <v-list-item-action v-else-if="item.type === 'org'" class="user-avatar">
            <v-icon light v-text="$vuetify.icons.values.organization" class="fa-fw"></v-icon>
          </v-list-item-action>
          <v-list-item-action v-else class="user-avatar">
            <v-icon light v-text="$vuetify.icons.values.user"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title color="primary">
              {{ item.display }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="item.refname === contextRef">
            <v-icon small light v-text="$vuetify.icons.values.check" class="fa-fw"></v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list-group>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { NAMESPACE as APP_NAMESPACE } from '@argon/app/store'
import { NAMESPACE as ME_NAMESPACE } from '@argon/iam/me/store'
import { NAMESPACE as ORG_NAMESPACE } from '@argon/iam/organizations/store'
export default {
  name: 'ContextSelector',
  data: () => ({
    menu: false,
    x: 0,
    y: 0
  }),
  computed: {
    ...mapGetters(APP_NAMESPACE, ['contextType', 'contextRef', 'contextAvatar', 'contextDisplay']),
    ...mapState(APP_NAMESPACE, ['isMultiOrg']),
    ...mapState(ME_NAMESPACE, ['organizations', 'profile']),
    ...mapState(ORG_NAMESPACE, ['activeOrg']),
    items() {
      return [
        { header: this.$t('users') },
        { ...this.profile, type: 'user' },
        { header: this.$t('organizations') },
        ...this.organizations.map((item) => ({ ...item, type: 'org' }))
      ]
    },
    targetRoute() {
      if (this.contextType === 'org') {
        return {
          name: 'orgOverview',
          params: { orgRef: this.contextRef }
        }
      }
      return { path: '/me/overview' }
    }
  },
  filters: {
    upper: (value) => (value ? value.toUpperCase() : '')
  },
  methods: {
    ...mapActions(APP_NAMESPACE, ['setContextObj']),
    ...mapActions(ORG_NAMESPACE, ['setActiveOrgFromRef']),
    getRoute(value) {
      return new Promise((resolve, reject) => {
        if (value.type === 'org') {
          this.setActiveOrgFromRef({ orgRef: value.refname })
            .then(() => {
              if (this.isMultiOrg) {
                let routeName = !['me', 'overview', 'boardCard'].includes(this.$route.name)
                  ? this.$route.name
                  : 'orgOverview'
                let goto = {
                  name: routeName,
                  params: { ...this.$route.params, orgRef: value.refname }
                }
                return resolve(goto)
              }
              return resolve({ path: '/overview' })
            })
            .catch(() => {
              return resolve({
                name: 'signin',
                query: { redirect: this.$route.path }
              })
            })
        } else {
          return resolve({ path: '/me/overview' })
        }
      })
    },
    setContext(value) {
      this.setContextObj(value)
      this.getRoute(value).then((route) => {
        this.goToRoute(route)
      })
    },
    goToRoute(route) {
      if ((route.params && this.$route.params !== route.params) || (route.path && this.$route.path !== route.path)) {
        this.$router.push(route)
      }
      this.menu = false
    }
  }
}
</script>

<style scoped lang="scss">
.user-avatar {
  min-width: unset;
  margin-right: 16px !important;
}

::v-deep .v-list-group__header .v-list-group__header__append-icon {
  .v-icon {
    font-size: 16px !important;
    margin-right: 4px;
  }
}

.v-list {
  .v-list-item {
    .v-list-item__title {
      font-size: 16px !important;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "organizations": "@:labels.organizations",
    "select": "Context",
    "title": "Switch Context",
    "users": "@:labels.users"
  },
  "fr": {
    "organizations": "@:labels.organizations",
    "select": "Contexte",
    "title": "Changer de contexte",
    "users": "@:labels.users"
  }
}
</i18n>
